/* eslint-disable*/
/* eslint-disable no-unused-vars */
/* eslint-disable operator-linebreak */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TableColumn } from 'react-data-table-component';

import Arrow from 'src/assets/arrow-left-black.svg';

import {
  AlertAdapter,
  CommonDropdown,
  ICommonDropdownOption,
  RegularButton,
  SearchInput,
  CustomCheckBox,
} from 'pg-ui-library';

import { useTypedSelector } from 'src/hooks/useTypedSelector';

import useDebounce from 'src/hooks/useDebounce';
import { NewHireExceptionModal, SettingsButton } from 'src/components';
import { EmployeeListTable } from 'src/components/employee-list-table';

import EmployeesService from 'src/services/employees.service';
import { dropdownOptions1 } from 'src/components/employee-list-table/mocks/employee-list.mocks';
import { IEmployee } from 'src/interfaces/employee';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import useRolePermission from 'src/hooks/useRolePermission';
import { RolePermission } from 'src/components/sidebar';
import { toCamelCase } from 'src/utils/toCamelCase';
import { createObjectWithSelectedKeys } from 'src/utils/createObjectWithSelectedKeys';
import { AiOutlineDown } from 'react-icons/ai';
import {
  Container,
  ItemContainer,
  ArrowBack,
  NavTextLink,
  ItemContainerHeader,
  PageTitle,
  HeaderLeftItems,
  HeaderRightItems,
  EmployementStatusTitle,
  HeaderLeftFirstItem,
  HeaderLeftSecondItem,
  ButtonDropdown,
  ButtonDivDropdown,
} from './styles';

const EmployeeListPage: React.FC = () => {
  const [selectedEmployees, setSelectedEmployees] = useState<IEmployee[]>([]);
  const handleChange = ({ selectedRows, allSelected }: { selectedRows: IEmployee[]; allSelected: boolean }) => {
    setSelectedEmployees(selectedRows);
  };
  const [selectedExportType, setSelectedExportType] = useState({ name: 'Export Table', value: 'table' });
  const [dropdownActive, setDropdownActive] = useState<boolean>(false);
  const [dropdownTypeOptions, setDropdownTypeOptions] = useState<ICommonDropdownOption[]>([
    {
      key: 'All',
      label: 'Export All',
      value: 'all',
    },
    {
      key: 'table',
      label: 'Export Table',
      value: 'table',
    },
  ]);

  const employeeListInitialColumns = [
    {
      name: 'Company Name',
      selector: (row: IEmployee) => row.employeeClass,
      sortField: 'id',
      width: '120px',
      omit: false,
    },
    {
      name: 'Employee ID',
      selector: (row: IEmployee) => row.employeeId,
      sortField: 'id',
      width: '120px',
      omit: false,
    },
    // {
    //   name: 'SSN',
    //   selector: (row: IEmployee) => row.ssn,
    //   width: '180px',
    //   omit: false,
    // },
    {
      name: 'First Name',
      selector: (row: IEmployee) => row.firstName,
      width: '180px',
      sortField: 'firstName',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Last Name',
      selector: (row: IEmployee) => row.lastName,
      width: '180px',
      sortField: 'firstName',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Full Name',
      selector: (row: IEmployee) => row.name,
      width: '180px',
      sortField: 'firstName',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Birth Date',
      selector: (row: IEmployee) => {
        if (!row.birthDate) return '';
        const dateStr = String(row.birthDate);
        if (dateStr.length >= 4) {
          return `${dateStr.slice(0, -4)}****`;
        }
        return dateStr;
      },
      width: '180px',
      sortField: 'birthDate',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Work Location',
      selector: (row: IEmployee) => row.workLocation,
      width: '180px',
      omit: false,
      wrap: true,
    },
    {
      name: 'Department',
      selector: (row: IEmployee) => row.department,
      width: '180px',
      omit: false,
    },
    {
      name: 'Job',
      selector: (row: IEmployee) => row.job,
      width: '180px',
      omit: true,
    },
    {
      name: 'Position',
      selector: (row: IEmployee) => row.position,
      width: '180px',
      omit: true,
    },
    {
      name: 'Email',
      selector: (row: IEmployee) => {
        if (!row.email) return '';
        const email = String(row.email);
        if (email.length >= 4) {
          return `****${email.slice(4)}`;
        }
        return email;
      },
      width: '300px',
      sortField: 'primaryContactEmail',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Employee Class',
      selector: (row: IEmployee) => row.employeeClass,
      width: '300px',
      sortField: 'employeeClass',
      omit: true,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Employment Type',
      selector: (row: IEmployee) => row.employmentType,
      width: '200px',
      omit: true,
      sortable: false,
      reorder: true,
    },
    {
      name: 'Employment Status',
      selector: (row: IEmployee) => row.employmentStatus,
      width: '200px',
      omit: false,
      sortable: false,
      reorder: true,
    },
    {
      name: 'City',
      selector: (row: IEmployee) => row.city,
      width: '200px',
      sortField: 'city',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'State',
      selector: (row: IEmployee) => row.state,
      width: '200px',
      sortField: 'state',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Zip Code',
      selector: (row: IEmployee) => row.zipCode,
      width: '200px',
      sortField: 'zipCode',
      omit: true,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Home Address',
      selector: (row: IEmployee) => row.homeAddress,
      width: '200px',
      omit: true,
      sortable: false,
      reorder: true,
    },
    {
      name: 'Phone Number',
      selector: (row: IEmployee) => {
        if (!row.phoneNumber) return '';
        const phone = String(row.phoneNumber);
        if (phone.length >= 4) {
          return `****${phone.slice(4)}`;
        }
        return phone;
      },
      width: '200px',
      omit: false,
      sortable: false,
      reorder: true,
    },
    {
      name: 'Marital Status',
      selector: (row: IEmployee) => row.maritalStatus,
      width: '200px',
      sortField: 'maritalStatus',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Gender',
      selector: (row: IEmployee) => row.gender,
      width: '200px',
      sortField: 'gender',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Hire Date',
      selector: (row: IEmployee) => row.hireDate,
      width: '200px',
      sortField: 'hireDate',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Rehire Date',
      selector: (row: IEmployee) => row.rehireDate,
      width: '200px',
      sortField: 'rehireDate',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Termination Date',
      selector: (row: IEmployee) => row.terminationDate,
      width: '200px',
      sortField: 'terminationDate',
      omit: false,
      sortable: true,
      reorder: true,
    },
    {
      name: 'Is New Hire',
      selector: (row: IEmployee) => (row.isNewHire ? 'Yes' : 'No'),
      width: '200px',
      sortField: 'isNewHire',
      omit: false,
      sortable: true,
      reorder: true,
    },
  ];

  const { t } = useTranslation();
  const [columns, setColumns] = useState<TableColumn<IEmployee>[]>(employeeListInitialColumns);
  const { hasRolePermission } = useRolePermission();
  const [enableCSVDownload, setEnableCSVDownload] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');
  const { config } = useTypedSelector(state => state.config.data);
  const [newHireExceptionModal, setNewHireExceptionModal] = useState<boolean>(false);
  const [loadingExport, setLoadingExport] = useState<boolean>(false);
  const companyId = config?.selectedCompanyId;

  // Debounce the search term so that we only perform the search
  // after the user has stopped typing for 500ms
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const { employees, employeesStatus } = useTypedSelector(state => state.employees.data);
  const [employeeStatus, setEmployeeStatus] = useState<string>(employeesStatus ? '1' : '0');
  const [showAllEmployee, setShowAllEmployee] = useState<boolean>(false);

  const handleChangeAllSearch = () => {
    setShowAllEmployee(!showAllEmployee);
  };
  const handleEmployeeStatus = (value: string) => {
    setEmployeeStatus(value);
  };

  useEffect(() => {
    if (employees.length) {
      setEnableCSVDownload(true);
    } else {
      setEnableCSVDownload(false);
    }
  }, [employees]);

  const exportToExcelTable = async () => {
    setLoadingExport(true);
    const columnsToShow = columns
      .filter(col => col.omit === false)
      .map(col => toCamelCase(col.name as string) as keyof IEmployee);

    if (selectedEmployees.length > 0) {
      const empWithColumns = selectedEmployees.map(emp => createObjectWithSelectedKeys(emp, columnsToShow));

      exportToXLSX(empWithColumns, 'employees', 'employees');
    } else {
      const empWithColumns = employees.map(emp => createObjectWithSelectedKeys(emp, columnsToShow));

      exportToXLSX(empWithColumns, 'employees', 'employees');
    }
    setLoadingExport(false);
  };

  const exportToExcelAll = async () => {
    if (hasRolePermission(RolePermission.SUPER_ADMIN)) {
      setLoadingExport(true);
      const link = await EmployeesService.getAllEmployeesFromCompany(
        config?.selectedCompanyId as unknown as '',
        showAllEmployee,
        employeeStatus,
        searchTerm
      );
      const aElement = document.createElement('a');
      aElement.href = link;
      aElement.target = '_blank';
      aElement.click();
      setLoadingExport(false);
    } else {
      AlertAdapter('You do not have sufficient permission', 'error');
    }
  };

  return (
    <Container>
      <ItemContainerHeader>
        <HeaderLeftItems>
          <HeaderLeftFirstItem>
            <NavTextLink to="/employee-management">
              <ArrowBack src={Arrow} />
            </NavTextLink>
            <PageTitle>{t('employeeList.pageTitle')}</PageTitle>
          </HeaderLeftFirstItem>
          <HeaderLeftSecondItem>
            <EmployementStatusTitle>{t('employeeList.dropdown.employmentStatus')}</EmployementStatusTitle>
            <CommonDropdown
              label=""
              id="employeeStatus"
              name="employeeStatus"
              value={employeeStatus}
              setValue={handleEmployeeStatus}
              options={dropdownOptions1}
              wrapperStyle={{ width: '100%', marginRight: '13px' }}
              selectStyle={{ maxWidth: 'none', width: '100%' }}
            />
          </HeaderLeftSecondItem>
        </HeaderLeftItems>
        <HeaderRightItems>
          <SearchInput
            value={searchTerm}
            placeholder="Search..."
            handleChange={event => {
              let newValue = event.target.value;
              newValue = newValue.replace(/[',.]/g, '');
              setSearchTerm(newValue);
            }}
          />
          {hasRolePermission(RolePermission.SUPER_ADMIN) && (
            <RegularButton
              onClick={() => {
                setNewHireExceptionModal(true);
              }}
              disabled={selectedEmployees?.length === 0}
            >
              {t('global.form.newHireException')}
            </RegularButton>
          )}
          <div style={{ display: 'flex' }}>
            {/* <div>
              <RegularButton
                onClick={() => {
                  if (!selectedExportType.value) return;
                  selectedExportType.value === 'table' ? exportToExcelTable() : exportToExcelAll();
                }}
              >
                {selectedExportType.name ? selectedExportType.name : 'Export Table'}
              </RegularButton>
              {dropdownActive ? (
                <ButtonDropdown>
                  {dropdownTypeOptions.map(list => {
                    return (
                      <div>
                        <ButtonDivDropdown
                          onClick={() => {
                            setSelectedExportType({ name: list.label, value: list.value });
                            setDropdownActive(!dropdownActive);
                          }}
                        >
                          {list.label}
                        </ButtonDivDropdown>
                        <hr />
                      </div>
                    );
                  })}
                </ButtonDropdown>
              ) : (
                ''
              )}
            </div> */}
            {/* <RegularButton
              onClick={() => setDropdownActive(!dropdownActive)}
              style={{ marginLeft: '-7%', borderLeft: '0.5px white solid', width: '15px' }}
            >
              <AiOutlineDown style={{ marginLeft: '-7px', marginTop: '2px' }} />
            </RegularButton> */}
          </div>
          <SettingsButton columns={columns} setColumns={setColumns} />
        </HeaderRightItems>
      </ItemContainerHeader>
      <NewHireExceptionModal
        newHireException={selectedEmployees.map(emp => emp.id)}
        isOpen={newHireExceptionModal}
        setNewHireExceptionModal={setNewHireExceptionModal}
      />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CustomCheckBox
          label={t('employeeList.EnableAllSearch')}
          id={'item.name'}
          name={'item.name'}
          checked={showAllEmployee}
          onChange={() => handleChangeAllSearch()}
        />
        <hr style={{ flex: '1', margin: '0 0 0.5em 0.5em', border: 'none', borderTop: '1px solid #ccc' }} />
      </div>
      <ItemContainer>
        {companyId && (
          <EmployeeListTable
            enableGlobalSearch={showAllEmployee}
            searchTerm={debouncedSearchTerm}
            columns={columns}
            employeeStatus={employeeStatus}
            companyId={companyId}
            selectableRows
            onSelectedRowsChange={handleChange}
          />
        )}
      </ItemContainer>
    </Container>
  );
};
export default EmployeeListPage;
